<template>
  <div>
    <b-modal
      id="selected-activity-modal"
      hide-footer
      hide-header
      centered
      size="lg"
      content-class="p-2 text-center bg-light styled-modal centered pr-4 pl-4"
    >
      <ActivityDetails
        :activity="selectedActivityDetails"
        :booking-id="bookingId"
      />
      <button
        class="btn btn-link activity-btn text-dark pt-2"
        @click="closeModal"
      >
        {{ $t('lang.activities.close') }}
      </button>
    </b-modal>

    <h6
      v-if="textToShow"
      class="form-group mt-3"
    >
      <label
        class="container_check"
        @click="statusUpdate"
      >
        <span
          class="small"
          v-html="textToShow"
        />

        <input
          id="free-tour-included"
          ref="checkbox"
          type="checkbox"
          name="free-tour-included"
          checked
        >
        <span class="checkmark" />
      </label>
    </h6>
  </div>
</template>

<script>
import { API } from '@/api/api';
import ActivityDetails from '@/components/Activity/ActivityDetails.vue';

const ActivitiesAPI = API.get('activities');

export default {
  name: 'FreeTourIncluded',
  components: { ActivityDetails },
  props: {
    bookingId: {
      type: Number,
      required: false,
    },
    bookingStatus: {
      type: String,
      required: true,
    },
    selectedActivity: {
      type: Object,
      required: false,
    },
    selectedActivityDetails: {
      type: Object,
      required: false,
    },

  },
  data() {
    return {
      textToShow: '',
      defaultActivity: null,

    };
  },

  async created() {
    if (this.bookingStatus === 'pending') {
      try {
        const { data } = await ActivitiesAPI.getDefaultActivityForBooking({ booking_id: this.bookingId });
        if (data) {
          this.defaultActivity = data;

          this.$store.dispatch('setAdditionalFreeTour', this.defaultActivity);
          this.textToShow = ` ${this.$t('lang.activities.add_default_free_tour')} <b> ${this.shortTitle(this.defaultActivity.title)}</b>`;
        }
      } catch (error) {
        // not show
      }
    }
  },

  methods: {
    shortTitle(title) {
      if (title.length > 60) {
        return `${title.substring(0, 60)}...`;
      }
      return title;
    },

    statusUpdate() {
      if (this.$refs.checkbox.checked === false) {
        this.$store.dispatch('setAdditionalFreeTour', null);
      } else {
        this.$store.dispatch('setAdditionalFreeTour', this.defaultActivity);
      }
    },
    closeModal() {
      this.$bvModal.hide('selected-activity-modal');
    },
  },
};
</script>
<style scoped>

</style>
